module.exports = __webpack_public_path__ + "static/img/complex_good.4ad0362.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oneMachine/complex_good.png
// module id = m238
// module chunks = 0